<div class="container-multiple-dates">
  <mat-label class="container-multiple-dates__label" *ngIf="title">{{ translatedTitle }}</mat-label>
  <mat-form-field class="multiple-dates" appearance="fill" (click)="picker.open()">
    <mat-chip-grid #chipList aria-label="Fechas" (click)="picker.open()">
        <div class="chip-row">
          <mat-chip-row
            *ngFor="let value of arrayDates"
            [removable]="true"
            (removed)="removeDate(value)"
          >
            {{ formatDate(value) }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        </div>
        <input
          [formControl]="dateControl"
          matInput
          [matDatepicker]="picker"
          (dateChange)="dateChanged($event)"
          [matChipInputFor]="chipList"
          [matDatepickerFilter]="disableFutureDates"
          [max]="maxDate"
          hidden
        />
    </mat-chip-grid>
    <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker [startAt]="init" [dateClass]="dateClass"></mat-datepicker>
  </mat-form-field>
</div>

